export { ExtensionMarkSyncStatePlugin, registerExtensionMarkSyncStatePlugin } from './extension-mark-sync-state';
export * from './type';
